/* -------------------------------------------------------------------------- */
/*                                Dependencies                                */
/* -------------------------------------------------------------------------- */

// tanstack query
import { useMutation } from '@tanstack/react-query';

// api
import { apiClient } from '@lib/api-client';

// types
import { TMutationConfig } from '@lib/react-query';

/* -------------------------------------------------------------------------- */
/*                                     Type                                   */
/* -------------------------------------------------------------------------- */
type TUseDeleteProductionOptions = {
	mutationConfig?: TMutationConfig<
		typeof verifyProduction
	>;
};

/* -------------------------------------------------------------------------- */
/*                                     Api                                    */
/* -------------------------------------------------------------------------- */
export const verifyProduction = ({
	ids,
	verified,
}: {
	ids: string[];
	verified: boolean;
}) => {
	return apiClient.patch(`/productions/verify`, {
		ids,
		verified,
	});
};

/* -------------------------------------------------------------------------- */
/*                                     Hooks                                  */
/* -------------------------------------------------------------------------- */
export const useVerifyProduction = ({
	mutationConfig,
}: TUseDeleteProductionOptions = {}) => {
	return useMutation({
		...mutationConfig,
		mutationFn: verifyProduction,
	});
};
